import {MenuItem, MenuItemProps, styled} from "@mui/material";
import {BarekamIcon, BarekamIconProps} from "../../../components/icon/barekam-icon";

export const HeaderAddressMenuContent = styled('div')(({theme}) => ({
    display: 'flex',
    gap: '0.75rem',
    padding: '0.5rem',
    '& .MuiMenuItem-root:not(:last-child)': {
        borderBottom: `1px solid ${theme.barekam.mediumGrey}`,
    }
}));

export const AddressMenuItem = styled((props: MenuItemProps) => <MenuItem {...props} disableRipple/>)(() => ({
    '&.MuiMenuItem-root': {
        paddingTop: '0.25rem',
        paddingBottom: '0.25rem',
        paddingLeft: '1.5rem',
        paddingRight: '1.5rem',

        gap: '1.5rem',
        borderBottom: 'unset !important',
    },
    display: 'flex',
    justifyContent: 'space-between'
}));

export const AddressMenuItemBack = styled(AddressMenuItem)(() => ({
    '&.MuiMenuItem-root': {
        paddingLeft: '1.5rem',
        filter: 'invert(50%) sepia(59%) saturate(3919%) hue-rotate(185deg) brightness(108%) contrast(96%)',
    },
    '& img' : {
        rotate: '-270deg'
    },
    justifyContent: 'left',
}))

export const AddressMenuItemCountryName = styled('div')(() => ({
    whiteSpace: 'initial',
    width: '5rem'
}))

export const AddressMenuItemArrowIcon = styled((props: BarekamIconProps) =>
    <div style={{rotate: '-90deg'}}>
        <BarekamIcon {...props}/>
    </div>)(() => ({}))